<template>
    <div class="public_container">
        <div class="returnNavBar">
            <ReturnNavBar title="当前公司名称"></ReturnNavBar>
        </div>
        <div class="mobile_container">
            <div class="company_container">
                <ul>
                    <li v-for="(item,key) in companyList" :key="key" @click="handleClickSwitchCompany(item)">
                        <div class="cover">
                            <img :src="item.company_logo ? item.company_logo:'https://download.hecoos.com/enlightv/2024-42/ff3ed8b3abdc3c0c6c9c0be2f0cca9af.png'" alt="">
                        </div>
                        <div class="cont">
                            <h5 v-text="item.name"></h5>
                            <p v-text="item.username"></p>
                        </div>
                        <div class="icon">
                            <van-icon v-if="item.id == company_id" name="success" size="16px" color="#2990FF"/>
                            <van-icon v-else name="arrow" size="16px"/>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import ReturnNavBar from '@/components/mComponents/ReturnNavBar.vue'
import {mapState} from "vuex";
import {CompanySwitch} from "../../../api";
export default {
    name: 'Company',
    data () {
        return {
            companyList:[],
            company_id:0,
        }
    },
    computed: {
        ...mapState(['userInfo']),
    },
    created() {
        if(this.userInfo && this.userInfo.company){
            this.company_id = this.userInfo.user.company_id
            this.companyList = this.userInfo.company
        }

    },
    mounted () {

    },
    methods: {
        // 切换公司
        handleClickSwitchCompany(item){
            this.$toast.loading({
                message: '请稍后...',
                forbidClick: true,
                overlay:true
            });
            CompanySwitch({
                company_id: item.id
            }).then((res) => {
                if (res.code === 200) {
                    const userInfo = this.userInfo || {};
                    userInfo.user.company_id = item.id
                    userInfo.user.company_name = item.name
                    this.$store.dispatch("saveUserInfo", {...userInfo, token: res.data});
                    this.$toast({
                        message: "切换成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.$router.push({
                                name: 'mobileWorkBench'
                            })
                        },
                    });
                }
                this.$toast.clear();
            });

        },
    },
    components: {
        ReturnNavBar
    }
}
</script>

<style lang="scss" scoped>

</style>
